"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _user = require("@/api/user");
var _permission = require("@/utils/permission");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 权限判断函数
var _default = {
  name: 'loginLog',
  data: function data() {
    return {
      listLoading: true,
      formType: 'detail',
      userInfo: {},
      tableData: {
        data: [],
        total: 0
      },
      userFrom: {
        account: '',
        nickname: '',
        ip: '',
        page: 1,
        limit: 15,
        is_spread: 1
      },
      multipleSelection: []
    };
  },
  mounted: function mounted() {
    if (this.$route.query.ip) {
      this.userFrom.ip = this.$route.query.ip;
    }
    this.getList();
  },
  methods: {
    checkPermi: _permission.checkPermi,
    /** 搜索按钮操作 */handleQuery: function handleQuery() {
      this.getList();
    },
    /** 重置按钮操作 */resetQuery: function resetQuery() {
      this.userFrom = _objectSpread(_objectSpread({}, this.userFrom), {}, {
        account: '',
        nickname: '',
        ip: '',
        is_spread: 1
      }), this.handleQuery();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 列表
    getList: function getList() {
      var _this = this;
      this.listLoading = true;
      (0, _user.getLoginLogList)(_objectSpread({}, this.userFrom)).then(function (res) {
        _this.tableData.data = res.data;
        _this.tableData.total = res.total;
        _this.listLoading = false;
      }).catch(function () {
        _this.listLoading = false;
      });
    },
    pageChange: function pageChange(page) {
      this.userFrom.page = page;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.userFrom.limit = val;
      this.getList();
    },
    // 删除
    handleDelete: function handleDelete(data, idx) {
      var _this2 = this;
      this.$modalSure().then(function () {
        var id_list = [];
        if (data) {
          id_list = [data.id];
        } else {
          id_list = _this2.multipleSelection.map(function (item) {
            return item.id;
          });
        }
        (0, _user.deleteUserOperateLog)({
          id_list: id_list
        }).then(function () {
          _this2.$message.success(_this2.$t('sccg'));
          _this2.getList();
        });
      });
    }
  }
};
exports.default = _default;